import { Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, scrollToId, slug } from "../lib/site";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-ink pt-20 text-white" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo dark />
          <p className="mt-5 max-w-sm font-display text-2xl font-bold leading-snug" data-testid="footer-company-name">
            Go Trip Travels (OPC) Private Limited
          </p>
        </div>
        <div className="lg:col-span-4 space-y-4 text-sm">
          <a href="tel:+918655358848" className="flex items-center gap-3 text-zinc-300 transition-colors hover:text-go" data-testid="footer-phone">
            <Phone size={18} className="text-go" /> +91 8655358848 (Phone / WhatsApp)
          </a>
          <a href="mailto:gotrip080@gmail.com" className="flex items-center gap-3 text-zinc-300 transition-colors hover:text-go" data-testid="footer-email">
            <Mail size={18} className="text-go" /> gotrip080@gmail.com
          </a>
          <p className="flex items-start gap-3 text-zinc-300" data-testid="footer-address">
            <MapPin size={18} className="mt-0.5 shrink-0 text-go" />
            Office No. 405, Skylon Tower, Plot No. 37-A, Sector 19A, Vashi, Navi Mumbai - 400703
          </p>
        </div>
        <nav className="lg:col-span-3 grid grid-cols-2 gap-2 text-sm">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => scrollToId(n.id)} data-testid={`footer-nav-${slug(n.label)}`}
              className="text-left text-zinc-300 transition-colors hover:text-go">{n.label}</button>
          ))}
        </nav>
      </div>
      <p aria-hidden="true" className="mt-16 select-none font-body text-[13vw] lg:text-[8.5rem] font-bold leading-[0.95] tracking-[0.02em] text-go">
        Go Trip Travels.
      </p>
      <div className="flex flex-col gap-2 border-t border-white/10 py-6 text-xs text-zinc-400 sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} Go Trip Travels (OPC) Private Limited. All rights reserved.</span>
        <span className="font-mono uppercase tracking-[0.2em]">Vashi · Navi Mumbai</span>
      </div>
    </div>
  </footer>
);
